import { render } from "./MenuTab.vue?vue&type=template&id=242aba76&scoped=true"
import script from "./MenuTab.vue?vue&type=script&lang=js"
export * from "./MenuTab.vue?vue&type=script&lang=js"

import "./MenuTab.vue?vue&type=style&index=0&id=242aba76&lang=scss&scoped=true"
import "./MenuTab.vue?vue&type=style&index=1&id=242aba76&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242aba76"]])

export default __exports__